/**
 * 报告中心页面
 * 功能开发中
 */

import UnderDevelopment from '../../components/common/UnderDevelopment'

export default function ReportCenter() {
  return <UnderDevelopment title="报告中心" />
}
